/*
Formulario de registro y de modificacion de usuario/cliente de ilusiona
utilizado apartir de variables para modificar tamaños y vistas del componente
ir al pie de pagina, Proptypes
*/

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

// SERVICES
import ServiceUser from '../services/User'
import ServiceCenter from '../services/Center'
import ServiceLocation from '../services/Location'

// CONSTANT
import { CALCULATEAGE, FORMATDATE } from '../constants'

// COMPONENT
import Snackbar from '../components/Snackbar/Snackbar'
import AlertDialog from '../components/AlertDialog'
import DatePicker from '../components/DatePicker'

// PAGE
import PrivacityPolicy from '../pages/footer/PrivacyPolicy'

// #region CSS
import { makeStyles } from '@material-ui/core/styles'
import Fade from '@material-ui/core/Fade'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import ListSubheader from '@material-ui/core/ListSubheader'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import Typography from '@material-ui/core/Typography'
// import { getDisplayDate } from '@material-ui/pickers/_helpers/text-field-helper'
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '10px',
    display: 'flex'
  },
  border: {
    boxShadow: '0px 0px 3px 1px #9abf3a',
    paddingTop: '20px',
    paddingBottom: '20px',
    marginTop: '30px',
    marginBottom: '50px'
  },
  form: {
    width: '90%',
    marginTop: theme.spacing(3),
    paddingBottom: '20px'
  },
  link: {
    color: 'blue',
    cursor: 'pointer'
  },
  disabled: {},
  checkboxError: {
    borderStyle: 'solid',
    borderRadius: '5px',
    borderWidth: '1px',
    borderColor: 'red',
    marginTop: '1px'
  }
}))
// #endregion

export default function FormUser({ dataUser, userProfile, setResponse, token, options }) {
  console.log('FormUser V2 - RRLL 8.0')
  const classes = useStyles()
  if (!userProfile) {
    userProfile = 0
  }

  // #region Values
  const isMobile = options ? (!!options.isMobile) : false
  const isFidelizacion = options ? (!!options.isFidelizacion) : false
  const isRegister = options ? (!!options.isRegister) : false
  const isReadOnly = options ? (!!options.isReadOnly) : false
  const userId = dataUser ? dataUser.id : '0'
  const [listProvince, setListProvince] = useState([])
  const [listPopulation, setListPopulation] = useState([])
  const [listReason, setListReason] = useState([])
  const [optionsSelectProvinceCenter, setOptionsSelectProvinceCenter] = useState([])
  const [formValues, setFormValues] = useState({
    showFormUser: isRegister && isFidelizacion ? true : !isRegister,
    showSelectReason: dataUser ? (!!dataUser.reason) : false,
    showSnackBar: false,
    snackMessage: 'Datos modificados',
    // showRegister: true,
    showPassword: false,
    edit: !!(!isRegister && isFidelizacion),
    editPassword: false,
    editMail: false,
    errorMessage: '',
    showPrivacity: false,
    step: 0,
    fAlta: dataUser ? FORMATDATE(dataUser.fAlta) : '',
    isActive: dataUser ? dataUser.active : false
  })
  /* const [values, setValues] = useState({
    isPrivacity: true,
    isPublicity: true,
    password: "Test",
    repassword: "Test",
    email: "carlos.mesa@neuritelab.com",
    mobile: "691464928",
    cp: "0821",
    idPopulation: "",
    idProvince: "",
    idCenter: "",
    gender: "1",
    born: "1993-12-15",
    dni: "79274015F",
    lastname: "Mesa Cabrera",
    name: "Carlos"
  }); */

  const [values, setValues] = useState({
    name: dataUser ? dataUser.name : '',
    lastname: dataUser ? dataUser.lastname : '',
    dni: dataUser ? dataUser.dni : '',
    documentType: dataUser ? dataUser.documentType : 'dni', // 'dni'
    born: dataUser ? dataUser.born : null,
    gender: dataUser ? dataUser.gender : '',
    cp: dataUser ? dataUser.cp : '',
    idProvince: dataUser ? dataUser.idProvince : '',
    idPopulation: dataUser ? dataUser.idPopulation : '',
    idCenter: dataUser ? dataUser.idCenter : '',
    mobile: dataUser ? dataUser.mobile : '',
    email: dataUser ? dataUser.email : '',
    publicObserv: dataUser ? dataUser.publicObserv : '',
    privObserv: dataUser ? dataUser.privObserv : '',
    reason: dataUser ? dataUser.reason : '',
    oldPassword: isRegister ? 'DontCheck' : '',
    password: '',
    repassword: '',
    isPrivacity: dataUser ? dataUser.isPrivacity : !!isFidelizacion,
    isPublicity: dataUser ? dataUser.isPublicity : !!isFidelizacion,
    idencr: dataUser ? dataUser.idencr : -1
  })
  const [checkValues, setCheckValues] = useState({
    name: false,
    lastname: false,
    dni: false,
    born: false,
    cp: false,
    idProvince: false,
    idPopulation: false,
    idCenter: false,
    gender: false,
    mobile: false,
    email: false,
    publicObserv: false,
    privObserv: false,
    reason: false,
    oldPassword: false,
    password: false,
    repassword: false,
    isPrivacity: false,
    isPublicity: false,
    idencr: -1
  })
  // #endregion

  // #region Dispatch
  const register = (token, user) => {
    return new Promise((resolve, reject) => {
      ServiceUser.INSTANCE.register(token, user)
        .then(user => {
          resolve()
        })
        .catch(error => {
          reject(error.response)
        })
    })
  }
  const changeUser = (token, userId, user, isChangePassword, isChangeMail) => {
    return new Promise((resolve, reject) => {
      ServiceUser.INSTANCE.changeUser(token, userId, user, isChangePassword, isChangeMail)
        .then(user => {
          resolve(user)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  }
  const getListProvince = (token, cp) => {
    return new Promise((resolve, reject) => {
      ServiceLocation.INSTANCE.getListProvince(token, cp)
        .then(listProvince => {
          resolve(listProvince)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  const getListReason = (token) => {
    return new Promise((resolve, reject) => {
      ServiceUser.INSTANCE.getListReason(token)
        .then(listProvince => {
          resolve(listProvince)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  const getListCenter = (token) => {
    return new Promise((resolve, reject) => {
      ServiceCenter.INSTANCE.getListCenter(token)
        .then(listProvince => {
          resolve(listProvince)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  const getListPopulation = (token, cp, idProvince) => {
    return new Promise((resolve, reject) => {
      ServiceLocation.INSTANCE.getListPopulation(token, cp, idProvince)
        .then(listPopulation => {
          resolve(listPopulation)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  const check = (token, dni, mobile, email) => {
    return new Promise((resolve, reject) => {
      ServiceUser.INSTANCE.check(token, dataUser ? dataUser.id : 0, dni, mobile, email)
        .then(r => {
          resolve(r)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  }
  // #endregion

  // #region Functions
  // Comprobamos y validamos el DNI
  const checkDNINIE = (dni) => {
    let numero, leta, letra
    let expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/

    dni = dni.toUpperCase()

    if (expresion_regular_dni.test(dni) === true) {
      numero = dni.substr(0, dni.length - 1)
      numero = numero.replace('X', 0)
      numero = numero.replace('Y', 1)
      numero = numero.replace('Z', 2)
      leta = dni.substr(dni.length - 1, 1)
      numero = numero % 23
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET'
      letra = letra.substring(numero, numero + 1)
      if (letra != leta) {
        // alert('Dni erroneo, la letra del NIF no se corresponde');
        return false
      } else {
        // alert('Dni correcto');
        return true
      }
    } else {
      // alert('Dni erroneo, formato no válido');
      return false
    }
  }

  /*
  // Comprobamos y validamos el Pasaporte
  const checkPassport = (passport) => {
    // Eliminamos espacios y convertimos a mayúsculas
    passport = passport.replace(/\s/g, '').toUpperCase()

    // Patrones comunes de pasaportes:
    // - Español: AAA123456 (3 letras + 6 números)
    // - Europeo general: AA1234567 (2 letras + 7 números)
    // - Internacional: A12345678 (1 letra + 8 números)
    // - Numérico: 123456789 (9 números)
    // - Alfanumérico mixto: AB1234567, ABC123456, etc.

    const patterns = [
      /^[A-Z]{3}\d{6}$/,        // Español: AAA123456
      /^[A-Z]{2}\d{7}$/,        // Europeo: AA1234567
      /^[A-Z]\d{8}$/,           // Internacional: A12345678
      /^\d{8,9}$/,              // Numérico: 12345678 o 123456789
      /^[A-Z]{1,3}\d{6,8}$/,    // Mixto: A123456, AB123456, ABC123456, etc.
      /^[A-Z]\d{7}[A-Z]$/,      // Algunos países: A1234567B
      /^[A-Z]{2}\d{6}[A-Z]$/    // Variante: AA123456B
    ]

    // Verificamos longitud mínima y máxima
    if (passport.length < 6 || passport.length > 12) {
      return false
    }

    // Verificamos que contenga al menos un carácter alfanumérico
    if (!/^[A-Z0-9]+$/.test(passport)) {
      return false
    }

    // Verificamos contra los patrones comunes
    return patterns.some(pattern => pattern.test(passport))
  }
  */

  // Hacemos comprobaciones especiales para cada uno de los atributos
  const checkSpecialCondition = (atribute, value) => {
    let result = {
      check: false,
      errorMessage: ''
    }
    switch (atribute) {
      case 'email':
        if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(value)) {
          result.check = true
          result.errorMessage = 'Formato del email incorrecto'
        } else {
          check(token, null, null, value)
            .then(v => {
              setCheckValues({
                ...checkValues,
                email: false
              })
              setFormValues({
                ...formValues,
                errorMessage: ''
              })
            })
            .catch(e => {
              setCheckValues({
                ...checkValues,
                email: true
              })
              setFormValues({
                ...formValues,
                errorMessage: 'Email ya registrado'
              })
            })
        }
        break
      case 'mobile':
        // Validación condicional según el tipo de documento
        {
          // const isPassport = values.documentType === 'passport'
          /* if (isPassport) {
            // Acepta formato internacional: permite espacios, guiones y prefijo '+'; conserva solo dígitos para el envío
            const digitsOnly = (value || '').replace(/[^\d]/g, '')
            if (digitsOnly.length >= 7 && digitsOnly.length <= 15) {
              check(token, null, digitsOnly)
                .then(v => {
                  setValues({
                    ...values,
                    mobile: digitsOnly
                  })
                  setCheckValues({
                    ...checkValues,
                    mobile: false
                  })
                  setFormValues({
                    ...formValues,
                    errorMessage: ''
                  })
                })
                .catch(e => {
                  setCheckValues({
                    ...checkValues,
                    mobile: true
                  })
                  setFormValues({
                    ...formValues,
                    errorMessage: 'Movil ya registrado'
                  })
                })
            } else {
              result.check = true
              result.errorMessage = 'Formato del móvil incorrecto.'
            }
          } else { */
            // Validación original del móvil español
            if (
              /^(\+34|34)?[ -]*(6|7)[ -]*([0-9])*$/.test(value) &&
              ((value.substring(0, 3) === '+34' && value.length === 12) || (value.substring(0, 2) === '34' && value.length === 11) || value.length === 9)
            ) {
              let telf = value.substring(value.length === 9 ? 0 : value.length === 11 ? 2 : 3, value.length)
              check(token, null, telf)
                .then(v => {
                  setValues({
                    ...values,
                    mobile: telf
                  })
                  setCheckValues({
                    ...checkValues,
                    mobile: false
                  })
                  setFormValues({
                    ...formValues,
                    errorMessage: ''
                  })
                })
                .catch(e => {
                  setCheckValues({
                    ...checkValues,
                    mobile: true
                  })
                  setFormValues({
                    ...formValues,
                    errorMessage: 'Movil ya registrado'
                  })
                })
            } else {
              result.check = true
              result.errorMessage = 'Formato del movil incorrecto.'
            }
          // }
        }
        break
      case 'born':
        let age = CALCULATEAGE(new Date(values.born))

        if (age < 18) {
          result.check = true
          result.errorMessage = 'Debes ser mayor de edad.'
        } else if (age > 100) {
          result.check = true
          result.errorMessage = 'Fecha de nacimiento incorrecta.'
        } else {
          result.check = false
          result.errorMessage = ''
        }
        break
      case 'dni':
        // Determinamos qué función de validación usar según el tipo de documento
        // const isPassport = values.documentType === 'passport'
        // const isValidDocument = isPassport ? checkPassport(value) : checkDNINIE(value)
        const isValidDocument = checkDNINIE(value)

        if (isValidDocument) {
          result.check = false
          result.errorMessage = ''

          // Solo verificamos duplicados si el documento tiene la longitud esperada
          /* const shouldCheckDuplicates = isPassport ?
            (value.replace(/\s/g, '').length >= 6) :
            (value.length === 9) */
          const shouldCheckDuplicates = (value.length === 9)

          if (shouldCheckDuplicates) {
            check(token, value)
              .then(v => {
                setCheckValues({
                  ...checkValues,
                  dni: false
                })
                setFormValues({
                  ...formValues,
                  errorMessage: ''
                })
              })
              .catch(e => {
                setCheckValues({
                  ...checkValues,
                  dni: true
                })
                setFormValues({
                  ...formValues,
                  errorMessage: 'DNI/NIE ya registrado' // isPassport ? 'Pasaporte ya registrado' : 'DNI/NIE ya registrado'
                })
              })
          }
        } else {
          result.check = true
          result.errorMessage = 'Formato DNI/NIE incorrecto' // isPassport ? 'Formato de pasaporte incorrecto' : 'Formato DNI/NIE incorrecto'
        }
        break
      case 'password':
        // !/^[a-z0-9_-]{6,16}$/i.test(value)
        if (!/^[a-z0-9@#$%&!*_-]{6,16}$/i.test(value)) {
          result.check = true
          result.errorMessage = 'La contraseña debe tener al menos entre 6 y 16 caracteres.'
        } else {
          result.check = false
          result.errorMessage = ''
        }
        break
      case 'repassword':
        // First check if the format is valid
        if (!/^[a-z0-9@#$%&!*_-]{6,16}$/i.test(value)) {
          result.check = true
          result.errorMessage = 'La contraseña debe tener al menos entre 6 y 16 caracteres.'
        }
        // Then check if passwords match
        else if (values.password !== value) {
          result.check = true
          result.errorMessage = 'Las contraseñas deberian coincidir.'
        } else {
          result.check = false
          result.errorMessage = ''
        }
        break
      default:
        break
    }

    return result
  }
  const checkFieldIsEmptyOrNoneSelected = () => {
    // COPY CheckValues
    let copyCheckValues = Object.assign({}, checkValues)
    let result = {
      check: true,
      errorMessage: ''
    }

    for (let atr in values) {
      let variable = values[atr]
      // console.log(atr, typeof variable, values[atr])
      const passportMode = values.documentType === 'passport'
      if (typeof variable === 'string') {
        if (checkValues[atr]) {
          result.check = false
        }
        // Skip required check for optional fields
        if (
          atr === 'gender' ||
          atr === 'publicObserv' ||
          atr === 'privObserv' ||
          atr === 'reason' ||
          atr === '_oldMail'
          // || (passportMode && (atr === 'cp' || atr === 'idProvince' || atr === 'idPopulation'))
        ) {
          continue
        }
        if (values[atr].trim().length === 0) {
          copyCheckValues[atr] = true
          setFormValues({
            ...formValues,
            errorMessage: 'Campos necesarios'
          })
          result.errorMessage = 'Campos necesarios'
          result.check = false
        }
      } else if (typeof variable === 'boolean') {
        if (!values[atr]) {
          if (result.errorMessage === 'Campos necesarios') {
            break
          } else {
            if (formValues.editPassword) {

            } else {
              if (atr !== 'isPublicity') {
                copyCheckValues[atr] = true
                setFormValues({
                  ...formValues,
                  errorMessage: 'Acepta las condiciones'
                })
                result.errorMessage = 'Acepta las condiciones'
                result.check = false
              }
            }
          }
        }
      } else if (typeof variable === 'object') {
        if (values[atr] === null) {
          // Skip null check for optional location fields
          /* if (passportMode && (atr === 'idProvince' || atr === 'idPopulation')) {
            continue
          } */
          copyCheckValues[atr] = true
          setFormValues({
            ...formValues,
            errorMessage: 'Campos necesarios'
          })
          result.errorMessage = 'Campos necesarios'
          result.check = false
        }
      } else if (typeof variable === 'undefined') {
        if (atr === 'idCenter') {
          setFormValues({
            ...formValues,
            errorMessage: 'Campo Centro es necesario'
          })
          result.errorMessage = 'Campo Centro es necesario'
          result.check = false
        }
      }
      if (!isRegister && atr === 'email' && !formValues.editPassword) {
        break
      }
    }

    if (formValues.showSelectReason) {
      if (!values.reason || values.reason === '') {
        result.errorMessage = 'Seleccione un motivo de bloqueo'
        result.check = false
        copyCheckValues.reason = true
      }
    }

    setCheckValues(copyCheckValues)
    return result
  }
  // Ordenamos los centros, primero con los de la provincia del usuario y los restantest
  const orderCentres = idProvince => {
    let options = []
    optionsSelectProvinceCenter.filter(t => t.props.id === idProvince).forEach(v => options.push(v))
    optionsSelectProvinceCenter.filter(t => t.props.id !== idProvince).forEach(v => options.push(v))

    setOptionsSelectProvinceCenter(options)
  }
  // Acciones especiales para codigo postal y provincia, llama a la API
  const specialAccionOnHandleChange = (prop, value) => {
    let copyFormValues = Object.assign({}, formValues)
    let copyValues = Object.assign({}, values)
    let copyCheckValues = Object.assign({}, checkValues)
    switch (prop) {
      case 'cp':
        if (value.length === 5) {
          copyValues.cp = value
          copyValues.idProvince = ''
          copyValues.idPopulation = ''
          getListProvince(token, value)
            .then(v => {
              setListProvince(v)
              if (v.length === 1) {
                orderCentres(v[0].idProvince)
                copyValues.idProvince = v[0].idProvince
                copyCheckValues.idProvince = false
              } else if (v.length === 0) {
                copyCheckValues.cp = true
                copyFormValues.errorMessage = 'No se ha encontrado la provincia.'
              }
              getListPopulation(token, value)
                .then(v => {
                  if (v.length === 1) {
                    setListPopulation(v)
                    copyValues.idPopulation = v[0].idPopulation
                    copyCheckValues.idPopulation = false
                  } else {
                    if (v.length != 0) {
                      setListPopulation(v)
                    } else {
                      setListPopulation([])
                    }
                  }
                  setValues(copyValues)
                  setCheckValues(copyCheckValues)
                  setFormValues(copyFormValues)
                })
                .catch(e => console.log(e))
            })
            .catch(e => console.log(e))
        }
        break
      case 'idProvince':
        getListPopulation(token, '', value)
          .then(v => {
            copyValues.idProvince = value

            orderCentres(value)
            setListPopulation(v)
            if (v.length === 1) {
              copyValues.idPopulation = v[0].idPopulation
            }
            setValues(copyValues)
            setFormValues(copyFormValues)
          })
          .catch(e => console.log(e))
        break
      default:
        break
    }
  }
  // #endregion

  useEffect(() => {
    if (values.cp && !isRegister) {
      getListProvince(token, values.cp).then(v => {
        setListProvince(v)
      })
      getListPopulation(token, values.cp).then(v => {
        setListPopulation(v)
      })
    }
    if (!isRegister && isFidelizacion) {
      getListReason(token).then(v => {
        setListReason(v)
      })
    }

    getListCenter(token).then(v => {
      let optionsSelect = []
      if (v) {
        v.listProvince.forEach(province => {
          optionsSelect.push(
            <ListSubheader id={province.id} key={province.id} disableSticky={true}>
              {province.name}
            </ListSubheader>
          )
          v.listCenter
            .filter(c => c.idProvince === province.id)
            .forEach(center => {
              optionsSelect.push(
                <MenuItem id={province.id} key={center.id} value={center.id}>
                  {center.name}
                </MenuItem>
              )
            })
        })
        setOptionsSelectProvinceCenter(optionsSelect)
      }
    })
  }, [])

  /*
  // Cuando el usuario seleccione pasaporte, limpiamos campos de población y los marcamos como no requeridos
  useEffect(() => {
    if (values.documentType === 'passport') {
      setValues(prev => ({
        ...prev,
        cp: '',
        idProvince: '',
        idPopulation: '',
      }))
      setCheckValues(prev => ({
        ...prev,
        cp: false,
        idProvince: false,
        idPopulation: false,
        // mantenemos la validación de centro
        idCenter: prev.idCenter === '' || prev.idCenter === null
      }))
    }
  }, [values.documentType])
  */

  // #region OnBlur
  const handleBlur = prop => event => {
    let check = checkSpecialCondition(prop, event.target.value)
    specialAccionOnHandleChange(prop, event.target.value)
    setValues({
      ...values,
      [prop]: event.target.value
    })
    setCheckValues({
      ...checkValues,
      [prop]: check.check
    })
    setFormValues({
      ...formValues,
      errorMessage: check.errorMessage
    })
  }

  const handleBlurDate = prop => event => {
    let check = checkSpecialCondition(prop, event.target.value)
    specialAccionOnHandleChange(prop, event.target.value)
    setCheckValues({
      ...checkValues,
      [prop]: check.check
    })
    setFormValues({
      ...formValues,
      errorMessage: check.errorMessage
    })
  }
  // #endregion

  // #region HandleChange
  const handleChange = prop => event => {
    // let check = checkSpecialCondition(prop, event.target.value);
    specialAccionOnHandleChange(prop, event.target.value)
    setValues({
      ...values,
      [prop]: event.target.value
    })
    setCheckValues({
      ...checkValues,
      [prop]: false
    })
    // setFormValues({ ...formValues, errorMessage: check.errorMessage });
  }
  const handleDateChange = date => {
    setValues({ ...values, born: date })
  }
  const handleClickBoolean = prop => event => {
    setValues({
      ...values,
      [prop]: !values[prop]
    })
    setCheckValues({
      ...checkValues,
      [prop]: false
    })
  }
  const handleChangeFormValuesBoolean = prop => event => {
    setFormValues({
      ...formValues,
      [prop]: !formValues[prop]
    })
  }
  const handleMouseDownPassword = event => {
    event.preventDefault()
  }
  // #endregion

  // #region OnClicks
  const onClickShowRegister = () => {
    setFormValues({
      ...formValues,
      showFormUser: true
    })
  }
  // envia un objeto login, para identeificar el callback desde la app origen y cerrar el dialogo
  const onClickBackLogin = () => {
    setResponse({ login: true })
  }
  // Mostrar la privacidad
  const onClickGoToPrivacity = () => {
    setFormValues({
      ...formValues,
      showPrivacity: !formValues.showPrivacity
    })
  }
  // envia un objeto corfirmation, para identeificar el callback desde la app origen y cerrar el dialogo
  const onClickBack = e => {
    e.preventDefault()
    let copyFormValues = Object.assign({}, formValues)
    copyFormValues.errorMessage = ''
    if (formValues.editMail) {
      copyFormValues.editMail = false
    } else if (formValues.editPassword) {
      copyFormValues.editPassword = false
    } else {
      copyFormValues.edit = false
      setResponse({ close: true })
    }
    setFormValues(copyFormValues)
  }
  // Submit del registro o la modificacion del usuario
  const onClickRegisterAndModified = e => {
    e.preventDefault()
    if (isReadOnly && !formValues.editPassword) {
      return
    }
    setResponse({ loading: true })

    // ControlFields
    let allCheck = checkFieldIsEmptyOrNoneSelected()

    setFormValues({
      ...formValues,
      errorMessage: allCheck.errorMessage
    })

    // Move camera top
    if (!allCheck.check) {
      const comp = document.querySelector('#root').offsetTop - 100
      window.scroll({
        behavior: 'smooth',
        top: comp
      })
      setResponse({ loading: false })
    }

    // Control all good
    if (allCheck.check) {
      // Sanitizamos los campos de población
      const valuesToSend = values // values.documentType === 'passport' ? { ...values, cp: '', idProvince: '', idPopulation: '', idCenter: '' } : values
      if (isRegister) {
        register(token, valuesToSend)
          .then(v => {
            if (isFidelizacion) {
              setFormValues({ ...formValues, showSnackBar: true, snackMessage: 'Registrado' })
            }
            setResponse({
              loading: false,
              registered: valuesToSend.email
            })
          })
          .catch(error => {
            setResponse({
              loading: false
            })
            if (error) {
              switch (error.status) {
                case 409:
                  setFormValues({
                    ...formValues,
                    errorMessage: 'Usuario ya registado'
                  })
                  break
                case 500:
                  setValues({
                    ...values,
                    errorMessage: 'Error del servidor, intente más tarde'
                  })
                  break
                default:
                  break
              }
            }
          })
      } else {
        let userMod
        if (isFidelizacion && !isRegister) {
          userMod = { ...valuesToSend, ...{ userId: dataUser.userId, centerUserId: dataUser.centerUserId, active: formValues.isActive } }
        } else {
          userMod = valuesToSend
        }
        let doFunct = (userIdPin) =>
          changeUser(token, userId, { ...userMod, userId: userIdPin }, formValues.editPassword, formValues.editMail)
            .then(user => {
              let copyFormValues = Object.assign({}, formValues)
              if (copyFormValues.editMail) {
                setResponse({
                  logout: values.email
                })
                copyFormValues.editMail = false
              }
              copyFormValues.editPassword = false
              copyFormValues.edit = false
              copyFormValues.errorMessage = ''
              copyFormValues.showSnackBar = true
              setFormValues(copyFormValues)
              setResponse({ modified: user })
            })
            .catch(error => {
              setResponse({ loading: false })
              if (error) {
                switch (error.status) {
                  case 409:
                    if (error.data === 'password') {
                      setFormValues({
                        ...formValues,
                        errorMessage: 'Error en la contraseña actual'
                      })
                    }
                    if (error.data === 'email') {
                      setFormValues({
                        ...formValues,
                        errorMessage: 'Email ya registrado'
                      })
                    }
                    break
                  default:
                    setFormValues({
                      ...formValues,
                      errorMessage: 'Error del servidor, intente más tarde'
                    })
                    break
                }
              }
            })
        if (isFidelizacion && !isRegister) {
          setResponse({ pin: 'pinEnter', function: doFunct })
        } else {
          doFunct()
        }
      }
    }
  }
  // Adelante en el registro del mobil
  const onClickNextRegisterMobile = e => {
    e.preventDefault()
    if (formValues.step < 3) {
      setFormValues({
        ...formValues,
        step: formValues.step + 1
      })
    } else {
      onClickRegisterAndModified(e)
    }
  }
  // Atras en el registro desdel mobil
  const onClickBackRegisterMobile = () => {
    if (formValues.step > 0) {
      setFormValues({
        ...formValues,
        step: formValues.step - 1
      })
    } else {
      onClickBackLogin()
    }
  }
  // Bloquear usuario
  const onClickBlockUser = () => {
    let copyFormValues = Object.assign({}, formValues)
    copyFormValues.errorMessage = ''
    copyFormValues.showSelectReason = !copyFormValues.showSelectReason
    setFormValues(copyFormValues)
    if (!copyFormValues.showSelectReason) {
      setValues({ ...values, reason: '' })
    }
  }
  // Eliminar usuario envia un objeto corfirmation, para identeificar el callback desde la app origen
  const onClickRemoveUser = () => {
    setResponse({ confirmation: true })
  }
  // Enviar la tarjeta del usuario
  const onClickSendCard = e => {
    e.preventDefault()
    setResponse({
      loading: true
    })
    changeUser(token, userId).then(() => {
      setFormValues({ ...formValues, showSnackBar: true, snackMessage: 'Tarjeta enviada' })
      setResponse({
        loading: false
      })
    })
  }
  // #endregion

  // #region Displays
  // #region FormUser
  const display18years = () => {
    return <Fade in={!formValues.showFormUser} timeout={1000}>
      <Grid
        container
        justify='center'
        alignItems='center'
        item
        xs={12}
        style={{
          ...(formValues.showFormUser ? { display: 'none' } : {})
        }}
      >
        <Grid container item xs={10} md={5} lg={3} xl={2} spacing={2} justify='center' alignItems='center' className={`${classes.border}`}>
          <Grid item xs={10}>
            <Box textAlign='center' marginTop='25px'>
              <p data-lang="age_check_title">¿Tienes más de 18 años?</p>
            </Box>
          </Grid>
          <Grid container item xs={10} md={8} lg={8} xl={6}>
            <Grid item xs={6}>
              <Button data-lang="no" variant='contained' color='secondary' onClick={onClickBackLogin}>
                No
              </Button>
            </Grid>
            <Grid container justify='flex-end' item xs={6}>
              <Button
                variant='contained' color='primary' style={{ color: 'white' }} onClick={onClickShowRegister} data-lang="yes"
              >
                Sí
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  }
  const displayTextFieldTitle = () => {
    return <Grid item xs={isFidelizacion && !isRegister ? 6 : 10}>
      <Box textAlign='center'>
        <Typography color='secondary' variant='h5'>
          {isRegister
            ? isFidelizacion
              ? <span data-lang="register_client_title">Registro de nuevo cliente</span>
              : <span data-lang="register_title">Registro de nuevo usuario</span>
            : formValues.editPassword
              ? <span data-lang="profile_change_password">Editar contraseña</span>
              : formValues.editMail
                ? <span data-lang="profile_change_email">Editar email</span>
                : isFidelizacion
                  ? <span data-lang="profile_title_client">Datos del cliente</span>
                  : <span data-lang="profile_title">Datos del usuario</span>}
        </Typography>
      </Box>
    </Grid>
  }
  const displayTextFieldError = () => {
    return formValues.errorMessage.length > 0 ? (
      <Grid item xs={12}>
        <div className='alert alert-danger' role='alert' data-lang={formValues.errorMessage}>
          {formValues.errorMessage}
        </div>
      </Grid>
    ) : null
  }
  const displayReadOnlyField = (label, value, dataLang) => {
    return <Grid item xs={12} sm={6}>
      <Box border={1} borderColor='grey.300' borderRadius={4} px={2} py={1}>
        <Typography variant='caption' color='textSecondary'>
          <span data-lang={dataLang}>{label}</span>
        </Typography>
        <Typography variant='body1'>{value || '-'}</Typography>
      </Box>
    </Grid>
  }
  const displayReadOnlyUser = () => {
    const gender = values.gender === 1 || values.gender === '1'
      ? <span data-lang='profile_gender_male'>Hombre</span>
      : values.gender === 2 || values.gender === '2'
        ? <span data-lang='profile_gender_female'>Mujer</span>
        : '-'

    return <React.Fragment>
      {displayReadOnlyField('Nombre', values.name, 'profile_name_label')}
      {displayReadOnlyField('Apellidos', values.lastname, 'profile_surname_label')}
      {displayReadOnlyField('DNI/NIE', values.dni, 'profile_dni_label')}
      {displayReadOnlyField('Fecha de nacimiento', values.born, 'profile_birthdate_label')}
      {displayReadOnlyField('Género', gender, 'profile_gender')}
      {displayReadOnlyField('Código postal', values.cp, 'profile_cp_label')}
      {displayReadOnlyField('Provincia', values.idProvince, 'profile_province_label')}
      {displayReadOnlyField('Población', values.idPopulation, 'profile_city_label')}
      {displayReadOnlyField('Centro', values.idCenter, 'profile_center')}
      {displayReadOnlyField('Móvil', values.mobile, 'profile_phone_label')}
      {displayReadOnlyField('Email', values.email, 'profile_email_label')}
    </React.Fragment>
  }
  const displayReadOnlyPreferences = () => {
    return <React.Fragment>
      {displayReadOnlyField('Privacidad', values.isPrivacity ? 'Sí' : 'No', 'profile_privacy')}
      {displayReadOnlyField('Publicidad', values.isPublicity ? 'Sí' : 'No', 'profile_publicity')}
    </React.Fragment>
  }
  const displayInputName = () => {
    return <Grid item xs={12} sm={6}>
      <TextField
        variant='outlined'
        required={isRegister || formValues.edit}
        error={!!checkValues.name}
        fullWidth
        label={<span data-lang="profile_name_label">Nombre</span>}
        autoComplete='name'
        autoFocus={!!checkValues.name}
        value={values.name}
        onChange={handleChange('name')}
        disabled={!isRegister && !formValues.edit}
      />
    </Grid>
  }
  const displayInputLastName = () => {
    return <Grid item xs={12} sm={6}>
      <TextField
        variant='outlined'
        required={isRegister || formValues.edit}
        error={!!checkValues.lastname}
        fullWidth
        label={<span data-lang="profile_surname_label">Apellidos</span>}
        autoComplete='lastname'
        autoFocus={!!checkValues.lastname}
        value={values.lastname}
        onChange={handleChange('lastname')}
        disabled={!isRegister && !formValues.edit}
      />
    </Grid>
  }
  /*
  const displayDocumentTypeRadio = () => {
    return <Grid item xs={12}>
      <FormControl component="fieldset">
        <FormLabel component="legend">Tipo de documento</FormLabel>
        <RadioGroup
          row
          value={values.documentType}
          onChange={handleChange('documentType')}
        >
          <FormControlLabel
            value="dni"
            control={<Radio color="primary" />}
            label="DNI/NIE"
          />
          <FormControlLabel
            value="passport"
            control={<Radio color="primary" />}
            label="Pasaporte"
          />
        </RadioGroup>
      </FormControl>
    </Grid>
  }
  */
  const displayInputDni = () => {
    const documentLabel = 'DNI/NIE' // values.documentType === 'passport' ? 'Pasaporte' : 'DNI/NIE'
    const documentPlaceholder = 'Número de DNI/NIE' // values.documentType === 'passport' ? 'Número de pasaporte' : 'Número de DNI/NIE'

    return <Grid item xs={12} sm={6}>
      <TextField
        variant='outlined'
        required={isRegister || formValues.edit}
        error={!!checkValues.dni}
        fullWidth
        label={<span data-lang="profile_dni_label">{documentLabel}</span>}
        placeholder={documentPlaceholder}
        inputProps={{
          'data-lang-attr': 'placeholder',
          'data-lang-placeholder': 'profile_dni_placeholder'
        }}
        autoComplete='DNI' // values.documentType === 'passport' ? 'passport' : 'DNI'
        value={values.dni}
        onChange={handleChange('dni')}
        onBlur={handleBlur('dni')}
        disabled={!isRegister && ![19, 0].includes(userProfile) && !formValues.edit}
      />
    </Grid>
  }
  const displayDateBorn = () => {
    return <Grid item xs={12} sm={6}>
      <DatePicker
        value={values.born}
        onChange={handleDateChange}
        onBlur={handleBlurDate('born')}
        disabled={!isRegister && !formValues.edit}
        required={isRegister || formValues.edit}
        error={!!checkValues.born}
      />
    </Grid>
  }
  const displaySelectGender = () => {
    return <Grid item xs={12} sm={6}>
      <FormControl variant='outlined' fullWidth>
        <InputLabel id='gender-select-outlined-label' error={!!checkValues.gender}>
          <span data-lang="profile_gender">Género</span>
        </InputLabel>
        <Select
          labelId='gender-select-outlined-label'
          id='gender-select-outlined'
          value={values.gender}
          onChange={handleChange('gender')}
          labelWidth={65}
          error={!!checkValues.gender}
          disabled={!isRegister && !formValues.edit}
        >
          <MenuItem value={0}> </MenuItem>
          <MenuItem value={1}><span data-lang="profile_gender_male">Hombre</span></MenuItem>
          <MenuItem value={2}><span data-lang="profile_gender_female">Mujer</span></MenuItem>
        </Select>
      </FormControl>
    </Grid>
  }
  const displayInputCP = () => {
    return <Grid item xs={12} sm={6}>
      <TextField
        variant='outlined'
        required={(isRegister || formValues.edit)} // && values.documentType !== 'passport'}
        error={!!checkValues.cp} // values.documentType !== 'passport' && !!checkValues.cp}
        fullWidth
        label={<span data-lang="profile_cp_label">CP</span>} // values.documentType === 'passport' ? 'CP (opcional)' : 'CP'}
        type='number'
        value={values.cp}
        onChange={handleChange('cp')}
        disabled={!isRegister && !formValues.edit}
      />
    </Grid>
  }
  const displaySelectProvince = () => {
    return <Grid item xs={12} sm={6}>
      <FormControl variant='outlined' fullWidth>
        <InputLabel id='province-select-outlined-label' required={(isRegister || formValues.edit)} error={!!checkValues.idProvince}>
          <span data-lang="profile_province_label">Provincia</span>
        </InputLabel>
        <Select
          labelId='province-select-outlined-label'
          id='province-select-outlined'
          value={values.idProvince}
          onChange={handleChange('idProvince')}
          labelWidth={85}
          error={!!checkValues.idProvince}
          disabled={(!isRegister && !formValues.edit) || listProvince.length === 0}
        >
          {listProvince.map(province => (
            <MenuItem key={province.idProvince} value={province.idProvince}>
              {province.province}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  }
  const displaySelectPopulation = () => {
    return <Grid item xs={12} sm={6}>
      <FormControl variant='outlined' fullWidth>
        <InputLabel id='population-select-outlined-label' required={(isRegister || formValues.edit)} error={!!checkValues.idPopulation}>
          <span data-lang="profile_city_label">Población</span>
        </InputLabel>
        <Select
          labelId='population-select-outlined-label'
          id='population-select-outlined'
          value={values.idPopulation}
          onChange={handleChange('idPopulation')}
          labelWidth={85}
          error={!!checkValues.idPopulation}
          disabled={(!isRegister && !formValues.edit) || listPopulation.length === 0}
        >
          {listPopulation.map(population => (
            <MenuItem key={population.idPopulation} value={population.idPopulation}>
              {population.population}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  }
  const displaySelectCenter = () => {
    return <Grid item xs={12} sm={6}>
      <FormControl variant='outlined' fullWidth>
        <InputLabel id='center-select-outlined-label' required={isRegister || formValues.edit} error={!!checkValues.idCenter}>
          <span data-lang="profile_center">Centro</span>
        </InputLabel>
        <Select
          labelId='center-select-outlined-label'
          id='center-select-outlined'
          value={values.idCenter}
          onChange={handleChange('idCenter')}
          labelWidth={70}
          defaultValue={''}
          error={!!checkValues.center}
          disabled={!isRegister || optionsSelectProvinceCenter.length === 0}
        >
          {optionsSelectProvinceCenter}
        </Select>
      </FormControl>
    </Grid>
  }
  const displayInputMobile = () => {
    return <Grid item xs={12} sm={6}>
      <TextField
        variant='outlined'
        required={isRegister || formValues.edit}
        error={!!checkValues.mobile}
        fullWidth
        label={<span data-lang="profile_phone_label">Móvil</span>}
        autoComplete='mobile'
        type='tel'
        value={values.mobile}
        onChange={handleChange('mobile')}
        onBlur={handleBlur('mobile')}
        disabled={!isRegister && !formValues.edit}
      />
    </Grid>
  }
  const displayInputMail = () => {
    return <Grid item xs={12}>
      <TextField
        id='txt_email'
        variant='outlined'
        required={isRegister || formValues.edit}
        error={!!checkValues.email}
        fullWidth
        label={<span data-lang="profile_email_label">Email</span>}
        type='email'
        autoComplete='email'
        value={values.email}
        onChange={handleChange('email')}
        onBlur={handleBlur('email')}
        disabled={!isRegister && !formValues.edit}
      />
    </Grid>
  }
  const displayInputOldPassword = () => {
    return formValues.editPassword ? (
      <Grid item xs={12}>
        <FormControl className={clsx(classes.margin, classes.textField)} variant='outlined' fullWidth>
          <InputLabel htmlFor='outlined-adornment-old-password' error={!!checkValues.oldPassword}>
            <span data-lang="profile_current_password">Contraseña actual *</span>
          </InputLabel>
          <OutlinedInput
            id='outlined-adornment-old-password'
            type={formValues.showPassword ? 'text' : 'password'}
            value={values.oldPassword}
            autoFocus
            error={!!checkValues.oldPassword}
            autoComplete='old-password'
            onChange={handleChange('oldPassword')}
            disabled={!isRegister && !formValues.edit}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  data-lang-attr="aria-label"
                  data-lang-aria-label="profile_toggle_password"
                  onClick={handleChangeFormValuesBoolean('showPassword')}
                  onMouseDown={handleMouseDownPassword}
                  edge='end'
                >
                  {formValues.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            labelWidth={155}
          />
        </FormControl>
      </Grid>
    ) : null
  }
  const displayInputPassword = () => {
    return <FormControl className={clsx(classes.margin, classes.textField)} variant='outlined' fullWidth>
      <InputLabel htmlFor='outlined-adornment-password' error={!!checkValues.password}>
        {formValues.editPassword ? <span data-lang="profile_new_password">Contraseña nueva * (min. 6)</span> : <span data-lang="profile_password">Contraseña * (min. 6)</span>}
      </InputLabel>
      <OutlinedInput
        id='outlined-adornment-password'
        type={formValues.showPassword ? 'text' : 'password'}
        value={values.password}
        error={!!checkValues.password}
        autoComplete='new-password'
        onChange={handleChange('password')}
        onBlur={handleBlur('password')}
        disabled={!isRegister && !formValues.edit}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              data-lang-attr="aria-label"
              data-lang-aria-label="profile_toggle_password"
              onClick={handleChangeFormValuesBoolean('showPassword')}
              onMouseDown={handleMouseDownPassword}
              edge='end'
            >
              {formValues.showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
        labelWidth={formValues.editPassword ? 160 : 160}
      />
    </FormControl>
  }
  const displayInputRePassword = () => {
    return <FormControl className={clsx(classes.margin, classes.textField)} variant='outlined' fullWidth>
      <InputLabel htmlFor='outlined-adornment-repassword' error={!!checkValues.repassword}>
        <span data-lang="profile_confirm_password">Repetir contraseña *</span>
      </InputLabel>
      <OutlinedInput
        id='outlined-adornment-repassword'
        type={formValues.showPassword ? 'text' : 'password'}
        value={values.repassword}
        error={!!checkValues.repassword}
        autoComplete='new-password'
        onChange={handleChange('repassword')}
        onBlur={handleBlur('repassword')}
        disabled={!isRegister && !formValues.edit}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              data-lang-attr="aria-label"
              data-lang-aria-label="profile_toggle_password"
              onClick={handleChangeFormValuesBoolean('showPassword')}
              onMouseDown={handleMouseDownPassword}
              edge='end'
            >
              {formValues.showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
        labelWidth={163}
      />
    </FormControl>
  }
  const displayCheckBoxPrivacity = () => {
    return <Grid item xs={12} className={`${checkValues.isPrivacity ? classes.checkboxError : null} pb-0`}>
      <FormControlLabel
        control={<Checkbox color='primary' onClick={handleClickBoolean('isPrivacity')} checked={values.isPrivacity} disabled={!isRegister} />}
        label={
          <label align='justify' className='mb-0'>
            <span data-lang="profile_privacy">Soy mayor de 18 años y declaro haber leído y acepto las condiciones de uso y la</span>
            <span className={classes.link} onClick={onClickGoToPrivacity} data-lang="profile_privacy_link">
              {' '}
              política de privacidad
            </span>
          </label>
        }
      />
    </Grid>
  }
  const displayCheckBoxPublicity = () => {
    return <Grid item xs={12} className={`${checkValues.isPublicity ? classes.checkboxError : null} pt-0`}>
      <FormControlLabel
        control={<Checkbox color='primary' onClick={handleClickBoolean('isPublicity')} checked={values.isPublicity} disabled={!isRegister} />}
        label={
          <label align='justify' className='mb-0'>
            <span data-lang="profile_publicity">Deseo recibir promociones del Club Ilusiona</span>
          </label>
        }
      />
    </Grid>
  }
  // #endregion
  // #region Fidelizacion control
  const displayTextFieldFalta = () => {
    return isFidelizacion && !isRegister ? <Grid item xs={6}>
      <Box textAlign='center'>
        <Typography variant='p'>
          <span data-lang="profile_registration_date">Fecha de alta: </span>
          {formValues.fAlta}
        </Typography>
      </Box>
    </Grid> : null
  }
  const displayInputObservations = () => {
    return <React.Fragment>
      {/* <Grid item xs={6}>
            <TextField
                value={values.publicObserv}
                id="outlined-multiline-static-public-desc"
                value={values.publicObserv}
                onChange={handleChange("publicObserv")}
                disabled={!isRegister && !formValues.edit}
                label="Observación pública"
                multiline
                rows="4"
                variant="outlined"
                fullWidth
            />
        </Grid> */}
      <Grid item xs={6}>
        <TextField
          value={values.privObserv}
          onChange={handleChange('privObserv')}
          disabled={!isRegister && !formValues.edit || ![14, 15, 18, 19, 0].includes(userProfile)}
          // label="Observación privada"
          label={<span data-lang="profile_observations">Observaciones</span>}
          multiline
          rows='4'
          variant='outlined'
          fullWidth
        />
      </Grid>
      <Grid item xs={6} />
    </React.Fragment>
  }
  const displayButtonBlockAndRemove = () => {
    if (!isRegister) {
      return <React.Fragment>
        <Grid item xs={6}>
          <Button
            disabled={![0, 18, 19].includes(userProfile)}
            fullWidth variant='contained' style={![0, 18, 19].includes(userProfile) ? { color: 'white', background: '#dfdddd', cursor: 'not-allowed' } : { color: 'white', background: '#f74d4d' }}
            onClick={onClickBlockUser}>
            {!formValues.showSelectReason ? <span data-lang="profile_block">Bloquear</span> : <span data-lang="profile_unblock">Desbloquear</span>}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            disabled={![0, 18, 19].includes(userProfile)}
            fullWidth variant='contained' style={![0, 18, 19].includes(userProfile) ? { color: 'white', background: '#dfdddd', cursor: 'not-allowed' } : { color: 'white', background: '#f74d4d' }}
            onClick={onClickRemoveUser}>
            <span data-lang="profile_delete">Eliminar</span>
          </Button>
        </Grid>
        <Grid item xs={6}>
          {displayCheckboxPublicityShort()}
        </Grid>
      </React.Fragment>
    } else {
      return null
    }
  }
  const displaySelectReasonBlock = () => {
    return <Grid item xs={12}>
      <FormControl variant='outlined' fullWidth>
        <InputLabel id='reason-select-outlined-label' disabled={listReason.length === 0} required={true} error={!!checkValues.reason}>
          <span data-lang="profile_block_reason">Motivo del bloqueo</span>
        </InputLabel>
        <Select
          labelId='reason-select-outlined-label'
          id='reason-select-outlined'
          value={values.reason}
          onChange={handleChange('reason')}
          labelWidth={145}
          error={!!checkValues.reason}
          disabled={!isRegister && !formValues.edit}
        >
          {listReason.map(reason => (
            <MenuItem key={reason.id} value={reason.id}>
              {reason.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  }
  const displayCheckboxPublicityShort = () => {
    return <FormControlLabel
      disabled={![0, 18, 19].includes(userProfile)}
      control={<Checkbox color='primary' style={{ marginLeft: '20px' }}
        onClick={handleClickBoolean('isPublicity')} checked={values.isPublicity} />}
      label={
        <label align='justify' className='mb-0'>
          <span data-lang="profile_publicity">Publicidad Club Ilusiona</span>
        </label>}
    />
  }
  // #endregion
  // #endregion

  return (
    <div className={classes.root}>
      <AlertDialog
        show={formValues.showPrivacity}
        setShow={v => { setFormValues({ ...formValues, showPrivacity: v }) }}
      >
        <PrivacityPolicy />
      </AlertDialog>
      <Snackbar show={formValues.showSnackBar}
        setShow={v => { setFormValues({ ...formValues, showSnackBar: v }) }}
        message={formValues.snackMessage}
      />

      <Grid container spacing={2} justify='center' alignItems='center'>
        {display18years()}
        {/* FormUser */}
        <Fade in={formValues.showFormUser} timeout={1000}>
          <Grid container item xs={10} md={isFidelizacion ? 10 : 8} lg={isFidelizacion ? 10 : 5} xl={2} spacing={2} justify='center' alignItems='center' className={classes.border}>
            {isMobile && !isReadOnly ? (
              <React.Fragment>
                <form className={classes.form} noValidate>
                  <Grid container spacing={2}>
                    {displayTextFieldError()}
                    <React.Fragment>
                      {formValues.step === 0 ? (
                        <React.Fragment>
                          {displayInputName()}
                          {displayInputLastName()}
                          {/* {displayDocumentTypeRadio()} */}
                          {displayInputDni()}
                          {displayDateBorn()}
                          {displaySelectGender()}
                        </React.Fragment>
                      ) : null}
                      {formValues.step === 1 ? (
                        <React.Fragment>
                          {displayInputCP()}
                          {displaySelectProvince()}
                          {displaySelectPopulation()}
                          {displaySelectCenter()}
                          {displayInputMobile()}
                        </React.Fragment>
                      ) : null}
                      {formValues.step === 2 ? (
                        <React.Fragment>
                          {displayInputMail()}
                          <Grid item xs={12}>
                            {displayInputPassword()}
                          </Grid>
                          <Grid item xs={12}>
                            {displayInputRePassword()}
                          </Grid>
                        </React.Fragment>
                      ) : null}
                      {formValues.step === 3 ? (
                        <React.Fragment>
                          {displayCheckBoxPrivacity()}
                          {displayCheckBoxPublicity()}
                        </React.Fragment>
                      ) : null}
                      <Grid item xs={12}>
                        <Button
                          type='submit' fullWidth variant='contained' color='primary'
                          style={{ color: 'white' }}
                          onClick={onClickNextRegisterMobile}
                        >
                          {formValues.step < 3 ? <span data-lang="next">Siguiente</span> : <span data-lang="register_button">Registrar</span>}
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Button fullWidth variant='contained' color='secondary' onClick={onClickBackRegisterMobile} data-lang="back">
                          Atrás
                        </Button>
                      </Grid>
                    </React.Fragment>
                  </Grid>
                </form>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {displayTextFieldTitle()}
                {displayTextFieldFalta()}
                <form className={classes.form} noValidate>
                  <Grid container spacing={2}>
                    {displayTextFieldError()}
                    {isReadOnly && !formValues.editMail && !formValues.editPassword ? displayReadOnlyUser() : formValues.editMail || formValues.editPassword ? null : (
                      <React.Fragment>
                        {displayInputName()}
                        {displayInputLastName()}
                        {/* {displayDocumentTypeRadio()} */}
                        {displayInputDni()}
                        {displayDateBorn()}
                        {displaySelectGender()}
                        {displayInputCP()}
                        {displaySelectProvince()}
                        {displaySelectPopulation()}
                        {displaySelectCenter()}
                        {displayInputMobile()}
                      </React.Fragment>
                    )}
                    {isRegister || formValues.editMail ? displayInputMail() : null}
                    {/* Passwords */}
                    {isRegister || formValues.editPassword ? (
                      <React.Fragment>
                        {displayInputOldPassword()}
                        <Grid item xs={12} sm={formValues.editPassword ? 12 : 6}>
                          {displayInputPassword()}
                        </Grid>
                        <Grid item xs={12} sm={formValues.editPassword ? 12 : 6}>
                          {displayInputRePassword()}
                        </Grid>
                      </React.Fragment>
                    ) : null}
                    {/* Descriptions */}
                    {isFidelizacion && !formValues.editMail && !formValues.editPassword ? (
                      <React.Fragment>
                        {displayInputObservations()}
                        {displayButtonBlockAndRemove()}
                        {formValues.showSelectReason ? displaySelectReasonBlock() : null}
                      </React.Fragment>
                    ) : null}
                    {/* CheckBoxes */}
                    {formValues.editMail || formValues.editPassword || (isFidelizacion && !isRegister) ? null : isReadOnly ? displayReadOnlyPreferences() : (
                      <React.Fragment>
                        {displayCheckBoxPrivacity()}
                        {displayCheckBoxPublicity()}
                      </React.Fragment>
                    )}
                    {/* Buttons */}
                    <Grid item xs={12}>
                      {isRegister ? (
                        <Button type='submit' fullWidth variant='contained' color='primary' style={{ color: 'white' }}
                          onClick={onClickRegisterAndModified} data-lang="register_button">
                          Registrar
                        </Button>
                      ) : null}
                      {!isRegister && !isReadOnly && !formValues.edit ? (
                        <Button fullWidth variant='contained' color='primary'
                          onClick={() => setFormValues({ ...formValues, edit: !formValues.edit })} data-lang="profile_edit">
                          Editar
                        </Button>
                      ) : null}
                      {isReadOnly && !formValues.editPassword ? (
                        <Button fullWidth variant='outlined' color='secondary'
                          onClick={e => {
                            e.preventDefault()
                            setFormValues({ ...formValues, editPassword: true })
                          }} data-lang="profile_change_password">
                          Cambiar contraseña
                        </Button>
                      ) : null}
                      {formValues.edit || (isReadOnly && formValues.editPassword) ? (
                        <Grid container spacing={2}>
                          {formValues.editMail || formValues.editPassword ? null : (
                            <React.Fragment>
                              {isFidelizacion
                                ? <Grid item xs={6}>
                                  <Button fullWidth variant='outlined' color='secondary'
                                    onClick={e => { onClickSendCard(e) }} data-lang="profile_send_card">
                                    Enviar tarjeta
                                  </Button>
                                </Grid>
                                : <Grid item xs={12} md={6}>
                                  <Button fullWidth variant='outlined' color='secondary'
                                    onClick={e => {
                                      e.preventDefault()
                                      setFormValues({
                                        ...formValues,
                                        editPassword: !formValues.editPassword
                                      })
                                    }} data-lang="profile_change_password">
                                    Cambiar contraseña
                                  </Button>
                                </Grid>
                              }
                              <Grid item xs={12} md={6}>
                                <Button fullWidth variant='outlined' color='secondary'
                                  disabled={![14, 15, 18, 19, 0].includes(userProfile)}
                                  onClick={e => {
                                    e.preventDefault()
                                    setFormValues({
                                      ...formValues,
                                      editMail: !formValues.e
                                    })
                                  }} data-lang="profile_change_email">
                                  Cambiar Email
                                </Button>
                              </Grid>
                            </React.Fragment>
                          )}
                          <Grid item xs={12} md={6}>
                            <Button fullWidth variant='contained' color='secondary' onClick={onClickBack} data-lang="back">
                              Atrás
                            </Button>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Button type='submit' fullWidth variant='contained'
                              color='primary' style={{
                                color: 'white'
                              }}
                              disabled={formValues.editMail && dataUser.email === values.email}
                              onClick={onClickRegisterAndModified}
                              data-lang="save"
                            >
                              Guardar
                            </Button>
                          </Grid>
                        </Grid>
                      ) : null}
                    </Grid>
                    {isRegister ? (
                      <Grid item xs={12}>
                        <Button fullWidth variant='contained' color='secondary' onClick={onClickBackLogin} data-lang="back">
                          Atrás
                        </Button>
                      </Grid>
                    ) : null}
                  </Grid>
                </form>
              </React.Fragment>
            )}
          </Grid>
        </Fade>
      </Grid>
    </div>
  )
}

FormUser.propTypes = {
  dataUser: PropTypes.object.isRequired, // Objeto con los datos del cliente
  userProfile: PropTypes.object.isRequired, // Objeto con los datos del perfil del usuario, para saber que acciones puede hacer el usuarios
  setResponse: PropTypes.func.isRequired, // Funcion callback para devolver resultados a la web de origen.
  token: PropTypes.string, // Token para realizar las peticiones a la API, con el identificador del usuario
  options: PropTypes.object // Opciones para identificar que displays necesitamos [isMobile, isFidelizacion, isRegister] para diferentes aplicaciones
}

/*
Aplicaciones:
-Web: [isMobile, isRegister] si isRegister===false y isFidelizacion===false significa que estamos en el perfil del cliente(en la web)
      [isMobile = true]
          estariamos desde un mobil donde  mostraremos en pequeños modulos el registro del cliente
      [isRegister = false]
          estamos en el perfil del usuario, para poder modificarlo
      [default]
          estariamos en la web convencional
-Fidelización:
      [isFidelizacion = true, isRegister = false]
          mostraremos displays para poder controlar el bloqueo del usuario, comentarios del usuario, eliminarlo, modificarlo,...
      [isFidelizacion = true, isRegister = true]
          podremos crear un nuevo usuario como si estuviesemos en la web
*/
